module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/049-tunisia-6961a27636c8ea9bf195020997b85fd4.svg";